module.exports = __webpack_public_path__ + "img/album20_01.c3f06679.jpg";